<script setup lang="ts">
import { computed } from 'vue';
import EGSAlert from '@/components/Alert/EGS_Alert.vue';
import { toastMessages, useToast } from '@/composables/useToast.ts';

defineOptions({ name: 'EGS_Toast' });
const props = withDefaults(defineProps<{ position?: string; group?: string }>(), { position: 'top-right', group: '' });
const toast = useToast();
const visibleMessages = computed(() => toastMessages.value.filter((message) => !props.group || message.group === props.group));
const positionClass = computed(() => [props.position.includes('top') ? 'top-24' : 'bottom-5', props.position.includes('left') ? 'left-5' : props.position.includes('center') ? 'left-1/2 -translate-x-1/2' : 'right-5']);
</script>

<template>
	<Teleport to="body">
		<div :class="['egs-toast fixed z-[11000] w-[min(25rem,calc(100vw-2rem))]', positionClass]" aria-live="polite">
			<TransitionGroup enter-active-class="transition duration-150 ease-out" enter-from-class="translate-y-1 opacity-0" leave-active-class="transition duration-100 ease-in" leave-to-class="translate-y-1 opacity-0">
				<EGSAlert v-for="message in visibleMessages" :key="message.id" :severity="message.severity || 'info'" :title="message.summary || ''" :closable="message.closable !== false" class="mb-3 shadow-lg" @close="toast.remove(message)">
					{{ message.detail }}
				</EGSAlert>
			</TransitionGroup>
		</div>
	</Teleport>
</template>
